export class AuthUser {
  constructor(
    public readonly id: string,
    public readonly email: string | null,
    public readonly emailVerified: boolean,
    public readonly createdAt: Date | null,
    public readonly lastSignInTime: Date | null,
  ) {}
}
